"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
const react_1 = require("react");
const useMediaQuery = (mediaQueryString) => {
    const queryString = mediaQueryString.replace("@media ", "").trim();
    const query = (0, react_1.useMemo)(() => window.matchMedia(queryString), [queryString]);
    const [matches, setMatches] = (0, react_1.useState)(query.matches);
    (0, react_1.useEffect)(() => {
        const handleChange = (e) => setMatches(e.matches);
        query === null || query === void 0 ? void 0 : query.addEventListener("change", handleChange);
        return () => query === null || query === void 0 ? void 0 : query.removeEventListener("change", handleChange);
    }, [query]);
    return matches;
};
exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map